<ng-container
  *ngIf="
    (visible$ | async) && {
      current: facade.currentOrganization$ | async,
      organizations: facade.organizations$ | async,
      loading: facade.loading$ | async,
      searchTerm: facade.searchTerm$ | async,
      previousTokens: facade.previousTokens$ | async,
      nextToken: facade.nextToken$ | async,
      totalCount: facade.totalCount$ | async,
      pageSize: facade.pageSize$ | async,
      mobile: mobile$ | async,
      hideArrows: facade.hideArrows$ | async,
      hasMoreItems: facade.hasMoreItems$ | async
    } as state
  "
>
  <span class="flex-row align-items-center organization-trigger" [matMenuTriggerFor]="organizationSelectionMenu">
    <ng-container *ngIf="loadingLogo$ | async; else loadedLogo">
      <img class="pulsating" src="assets/media/organization_placeholder.svg" alt="organization logo loading" />
    </ng-container>
    <ng-template #loadedLogo>
      <img
        [src]="facade.currentOrganizationLogo$ | async"
        fallbackSrc="assets/media/organization_placeholder.svg"
        alt="organization logo"
      />
    </ng-template>
    <i class="ri-arrow-down-s-line text-primary"></i>
  </span>

  <mat-menu #organizationSelectionMenu="matMenu" class="organization-selection-menu">
    <!-- Search and Pagination Controls -->
    <div
      class="menu-controls"
      [class.paginator-hidden]="state.hideArrows"
      (click)="$event.stopPropagation()"
      style="padding-left: 18px"
    >
      <ts-search-bar
        class="search-bar"
        [searchValue]="state.searchTerm"
        (searchChanged)="searchTermChanged($event)"
      ></ts-search-bar>
    </div>

    <!-- Organization List -->
    <div
      *ngIf="state.organizations?.length > 0"
      class="organization-list-container"
      (scroll)="onOrganizationListScroll($event, state.hasMoreItems, state.loading)"
    >
      <button
        mat-menu-item
        [disabled]="state.mobile"
        *ngFor="let org of state.organizations; trackBy: trackByOrgId"
        (click)="selectOrganization(org.id)"
        class="flex-row align-items-center"
        [class.active-org]="org.isCurrent"
      >
        <span class="active-indicator" [hidden]="!org.isCurrent"></span>
        <img
          [src]="org.logoUrl || 'assets/media/organization_placeholder.svg'"
          fallbackSrc="assets/media/organization_placeholder.svg"
        />
        <span class="org-name">{{ org.name }}</span>
      </button>

      <!-- Loading more indicator -->
      <div *ngIf="state.hasMoreItems" class="spinner-container">
        <mat-spinner diameter="24"></mat-spinner>
      </div>
    </div>

    <!-- Initial loading state -->
    <div
      *ngIf="state.loading && (state.organizations === undefined || state.organizations?.length === 0)"
      class="menu-loading"
      (click)="$event.stopPropagation()"
    >
      <i class="ri-loader-4-line spin"></i>
      <span>Loading...</span>
    </div>

    <!-- No results state -->
    <div
      *ngIf="!state.loading && state.organizations?.length === 0"
      class="menu-no-data"
      (click)="$event.stopPropagation()"
    >
      No organizations found
    </div>
  </mat-menu>
</ng-container>
